import { IKeySystemConfig } from 'src/interfaces/Drm';
import { detectIOS, detectSafari } from 'src/utils/browserUtils';
import { IVideoJsOptions } from 'src/interfaces/VideoJS';
import {
  SUBTITLE_BACKGROUND_OPTIONS,
  SUBTITLE_COLOR_OPTIONS,
  SUBTITLE_SIZE_OPTIONS,
  SUBTITLE_STROKE_OPTIONS,
} from 'src/interfaces/enums';

export const DEFAULT_VOLUME = 50;
export const DEFAULT_PLAYBACK_RATE = 1;
export const PATH_SUBTITLE = '/subtitle';

export const DEFAULT_PLAYER_OPTIONS = (): IVideoJsOptions => ({
  preload: 'metadata',
  autoplay: false,
  controls: false,
  techOrder: ['html5'],
  inactivityTimeout: 2000,
  html5: {
    vhs: {
      enableLowInitialPlaylist: false,
      limitRenditionByPlayerDimensions: false,
      useDevicePixelRatio: false,
      overrideNative: !detectIOS() && !detectSafari(),
      experimentalBufferBasedABR: false,
      isEncryptedUrl: false,
    },
    nativeAudioTracks: false,
    nativeVideoTracks: false,
  },
  nativeControlsForTouch: false,
  liveui: false,
  sourceOrder: true,
  poster: '',
  sources: [],
  liveTracker: {
    trackingThreshold: 0,
    liveTolerance: 1,
  },
  errorDisplay: false,
});

export const KEY_SYSTEM_CONFIG: IKeySystemConfig[] = [
  {
    initDataTypes: ['cenc'],
    audioCapabilities: [
      {
        contentType: 'audio/mp4;codecs="mp4a.40.2"',
      },
    ],
    videoCapabilities: [
      {
        contentType: 'video/mp4;codecs="avc1.42E01E"',
      },
    ],
  },
];

export const DEFAULT_SUBTITLE_STYLE = {
  color: SUBTITLE_COLOR_OPTIONS.yellow,
  background: SUBTITLE_BACKGROUND_OPTIONS.black,
  size: SUBTITLE_SIZE_OPTIONS.medium,
  stroke: SUBTITLE_STROKE_OPTIONS.regular,
};
